
import React, { useState, useEffect } from "react";
import { MaturityDashboardPageView } from "./maturity-dashboard-page-view";
import serviceProvider from '../../services/axios'
import { Link, Redirect } from "react-router-dom";
export const MaturityDashboardPageController = (props) => {

  const [results, setResults] = useState([]);
  const [tourComplete, setTourComplete] = useState("");
  
  const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
if (1) {
   
    return <Redirect to="/educate-prepare-home" />;
  }
  


  return (
    <>
      {/* <MaturityDashboardPageView {...props} /> */}
      <MaturityDashboardPageView homeData={results} onTourComplete={setTourComplete} {...props} />
    </>
  );
};
